import { api } from "./api";

const MARKETING = new Set([
  "/",
  "/real-device-testing-india",
  "/test-ai-generated-test-cases",
  "/vs-device-clouds-and-automation",
  "/vs/utest",
  "/vs/testlio",
  "/vs/browserstack-app-live",
  "/vs/test-io",
  "/vs/global-app-testing",
]);

function visitorId() {
  try {
    let id = localStorage.getItem("99t_vid");
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("99t_vid", id);
    }
    return id;
  } catch (e) {
    return null;
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem("99t_landing") || "null");
  } catch (e) {
    return null;
  }
}

export function trackPage(path) {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source") || params.get("ref") || null;
    const medium = params.get("utm_medium") || null;
    const campaign = params.get("utm_campaign") || null;
    if (MARKETING.has(path) && !localStorage.getItem("99t_landing")) {
      localStorage.setItem("99t_landing", JSON.stringify({ landing: path, source, medium, campaign }));
    }
    api.track({ path, referrer: document.referrer || "", source, medium, campaign, visitor_id: visitorId() });
  } catch (e) {}
}
